import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';

import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'settings';

export default class CheckLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: true,
      checking: true,
    };
  }

  async componentDidMount() {
    // Check if user exists in storage
    const user = await StorageHandler.load(storageKeys.user);

    if (!user) {
      this.setState({ loggedIn: false, checking: false });
      window.location.href = '/logout';
      return;
    }

    // Check if access token exists
    const tokenExists = await StorageHandler.exists(storageKeys.accessToken);

    if (!tokenExists) {
      this.setState({ loggedIn: false, checking: false });
      window.location.href = '/logout';
      return;
    }

    // Check if token is expired
    const tokenExpired = await StorageHandler.isExpired(
      storageKeys.accessToken
    );

    if (tokenExpired) {
      // Token is expired, redirect to logout
      window.location.href = '/logout';
      return;
    }

    // User and token are valid
    this.setState({ loggedIn: true, checking: false });
  }

  render() {
    const { loggedIn, checking } = this.state;

    // Don't redirect while checking to avoid flashing
    if (checking) {
      return null;
    }

    return <div>{!loggedIn && <Redirect to="/main/off" />}</div>;
  }
}
